<template>
  <div class="loginD">
    <div class="loginDCon">
      <div class="orgLogo">
        <!-- <img v-if="!isSkillHome" :src="loginUrl"> -->
      </div>
      <!-- <div v-if="switchLoginTypeShow=='true'&&loginStatus !=8" class="switchLoginTypeStyle">
        <span v-if="loginStatus==1" class="codeLoginStyle" @click="usernameLogin()" />
        <span v-else class="usernameLoginStyle" @click="codeLogin()" />

      </div> -->
      <ul class="loginTypeSwitch">
        <li class="loginTypeAction">
          {{ loginStatus | loginTitle }}
        </li>
      </ul>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
      >
        <el-form-item
          prop="mobile"
        >
          <el-input
            v-model="loginForm.mobile"
            class="loginInput"
            auto-complete="off"
            placeholder="请输入手机号"
          >
            <img slot="prefix" class="img-prefix" src="@/assets/img/phoneIcon.png" alt="">
          </el-input>
        </el-form-item>
        <el-form-item v-if="loginStatus==1" prop="password">
          <el-input

            v-model="loginForm.password"
            class="loginInput"
            :type="passw"
            auto-complete="off"
            placeholder="请输入账号密码"
            @keyup.enter.native="handleLogin('2')"
          >
            <img
              slot="prefix"
              src="@/assets/img/usernameLoginIcon.png"
              class="img-prefix passwordIcon"
              alt=""
            >
            <img
              v-show="showPassword"
              slot="suffix"
              width="24px"
              height="24px"
              class="img-prefix"
              src="@/assets/img/closeEyes.png"
              alt=""
              @click="showPass()"
            >
            <img
              v-show="!showPassword"
              slot="suffix"
              width="24px"
              height="24px"
              class="img-prefix"
              src="@/assets/img/openEyes.png"
              alt=""
              @click="showPass()"
            >
          </el-input>
        </el-form-item>
        <el-form-item v-if="loginStatus ==2 || loginStatus === 3" prop="formCode">
          <el-input
            v-model="loginForm.formCode"
            class="loginInput"
            auto-complete="off"
            placeholder="请输入短信验证码"
          >
            <img slot="prefix" class="img-prefix" src="@/assets/img/codeIcon.png" alt="">
            <a slot="suffix" style="color:#fff;" @click="getCode()">{{ forgetCodeBtnWord }}</a>
            <!-- <a
              v-show="!forgetPwd"
              slot="suffix"
              :class="forgetProhibit"
              @click="getCode()"
            >{{ forgetCodeBtnWord }}</a> -->
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="loginStatus ==2 || loginStatus === 3"
          prop="password"
        >
          <el-input
            v-model="loginForm.password"
            class="loginInput"
            :type="getPassw"
            auto-complete="off"
            placeholder="请输入8-16位密码"
          >
            <img
              slot="prefix"
              src="@/assets/img/usernameLoginIcon.png"
              class="img-prefix"
              alt=""
            >
            <!-- <svg-icon @click="showPass('1')" width="24px" height="24px" v-show="this.showGetPassword" slot="suffix" icon-class="closeEyes" class="el-input__icon input-icon" /> -->
            <!-- <svg-icon @click="showPass('1')" width="24px" height="24px" v-show="!this.showGetPassword" slot="suffix" icon-class="openEyes" class="el-input__icon input-icon" /> -->
            <img
              v-show="showGetPassword"
              slot="suffix"
              width="24px"
              height="24px"
              src="@/assets/img/closeEyes.png"
              alt=""
              @click="showPass('1')"
            >
            <img
              v-show="!showGetPassword"
              slot="suffix"
              width="24px"
              height="24px"
              src="@/assets/img/openEyes.png"
              alt=""
              @click="showPass('1')"
            >
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="loginStatus ==2 || loginStatus === 3"
          prop="confirm_password"
        >
          <el-input
            v-model="loginForm.confirm_password"
            class="loginInput"
            :type="passw"
            auto-complete="off"
            placeholder="再输入一次（密码必须保持一致）"
          >
            <img
              slot="prefix"
              src="@/assets/img/passwordIcon.png"
              class="img-prefix"
              alt=""
            >
            <img
              v-show="showPassword"
              slot="suffix"
              width="24px"
              height="24px"
              src="@/assets/img/closeEyes.png"
              alt=""
              @click="showPass('2')"
            >
            <img
              v-show="!showPassword"
              slot="suffix"
              width="24px"
              height="24px"
              src="@/assets/img/openEyes.png"
              alt=""
              @click="showPass('2')"
            >
          </el-input>
        </el-form-item>
        <el-form-item style="width: 100%">
          <div
            v-show="loginStatus ==1"
            class="passwordOperation
  "
          >
            <div class="CheckButton">
              <el-checkbox v-model="remember" class="loginCheckbox" />
              <span class="loginCheckboxText">记住密码</span>
            </div>
            <span class="forgetButton" @click="forgotPassword()">
              忘记密码
            </span>
          </div>
          <el-button
            v-show="loginStatus ==1"
            class="buttonlogin"
            :loading="loading"
            size="medium"
            style="width: 100%"
            @click.native.prevent="handleLogin('1')"
          >
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>

          <el-button
            v-show="loginStatus == 1 && isOpenRegister == 'true' "
            class="button-registered"
            size="medium"
            style="width: 100%"
            @click.native.prevent="handleRegist"
          >
            <span>注 册</span>
          </el-button>

          <el-button
            v-show="loginStatus == '2'"
            class="buttonlogin"
            :loading="loading"
            size="medium"
            type="primary"
            @click.native.prevent="handleLogin('2')"
          >
            <span v-if="!loading">确 定</span>
            <span v-else>确 定 中...</span>
          </el-button>
          
          <el-button
            v-show="loginStatus === 3"
            class="buttonlogin"
            :loading="loading"
            size="medium"
            style="width: 100%"
            @click.native.prevent="handleLogin(3)"
          >
            <span v-if="!loading">注 册</span>
            <span v-else>注 册 中...</span>
          </el-button>
          <div
            v-show="loginStatus ==2 || loginStatus === 3"
            class="operateButton"
          >
            <div class="usernameLoginStyle" type="text" style="color: #DD594A;" @click="usernameLogin()">
              使用账号登录
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { login, getInfo, sendCode, modifyPasswordByMobile, codeCheck,registerToYkbApi,globalConfigApi } from '@/http/index'
import { checkModbile, checkPwd3, checkPwd2 } from '@/utils/validate.js'
var result = null;
export default {
  name: "Login",
  filters:{
    loginTitle(loginVal){
      if(loginVal === 1){
        return '账号登录'
      } else if(loginVal === 2){
        return '手机号找回' 
      } else if(loginVal === 3){
        return '注册' 
      }
    }
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (checkModbile(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    };
    var checkPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.loginStatus == 1 ? '请输入密码' : '请输入新密码'))
      }
      if (this.loginStatus == 2) {
        setTimeout(() => {
          if (checkPwd2(value)) {
            this.$refs.loginForm.validateField("confirm_password");
            callback()
          } else {
            callback(new Error('请输入8-16位密码'))
          }
        }, 100)
      } else {
        callback()
      }
    };
    var checkPwdTwo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请再次输入新密码'))
      }
      setTimeout(() => {
        if (value !== this.loginForm.password) {
          callback(new Error('两次密码输入不一致'))
        } else {
          callback()
        }
      }, 100)
    };
    return {
      isOpenRegister:false,
      //   loginUrl: require("@/assets/images/loginLeftBox.png"),
      // 个人信息
      userInfo: undefined,
      // 登录状态
      loginStatus: 1, // 1:登录、2:忘记密码、3:注册、
      // 身份验证、新密码、设置密码文字
      // 获取验证码状态
      isCode: true,
      // 身份验证获取验证码状态
      forgetPwd: true,
      // 禁止身份验证获取验证码
      forgetProhibit: "",
      // 用于改变Input类型
      passw: "password",
      getPassw: "password",
      // 展示睁眼闭眼图标
      showPassword: true,
      showGetPassword: true,
      // 登录按钮加载禁用
      loading: false,
      // 登录表单
      loginForm: {
        mobile: "",
        password: "",
        rememberMe: false,
        rememberPassword: false,
        phone: "",
        code: "",
        onpassword: "",
        unpassword: "",
        provingCode: ""
      },
      remember: true,
      // 验证码登录倒计时
      waitTime: 61,
      // 验证码登录文字
      // 身份验证倒计时
      forgetWaitTime: 61,
      // 身份验证文字
      forgetCodeBtnWord: "获取短信验证码",
      // 登录校验
      loginRules: {
        mobile: [
          { trigger: 'blur', validator: checkPhone }
        ],
        password: [
          { validator: checkPwd, trigger: 'blur' }
        ],
        confirm_password: [
          { validator: checkPwdTwo, trigger: 'blur' }
        ],
        formCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      showCode: true,
      timer: '',
      code: null
    };
  },
  created() {
    if (localStorage.getItem('name')) {
      this.loginForm.mobile = localStorage.getItem('name')
    }
    if (localStorage.getItem('password')) {
      this.loginForm.password = localStorage.getItem('password')
    }
    this.globalConfig()
  },
  methods: {
    async globalConfig(){
      const res = await globalConfigApi({key:'is_open_register'})
      this.isOpenRegister = res.data.value
    },
    handleRegist(){
      this.reset();
      this.loginStatus = 3
    },
    // 切换账号登录
    usernameLogin() {
      this.reset();
      this.loginStatus = 1
    },

    // 忘记密码跳身份验证页面
    forgotPassword() {
      this.$refs["loginForm"].resetFields();
      this.$nextTick(() => {
        this.$refs["loginForm"].clearValidate();
      });
      this.reset();
      this.loginStatus = 2;
    },

    // 获取验证码
    getCode() {
      if (this.timer) return false
      if (!checkModbile(this.loginForm.mobile)) return this.$message.error('请输入正确的手机号码')
      this.sendCode();
    },
    async sendCode() {
      let res = null
      if(this.loginStatus === 3){
        res = await sendCode({ mobile: this.loginForm.mobile,type:'register' })
      }else{
        res = await sendCode({ mobile: this.loginForm.mobile })
      }
      
      if (res.code === 200) {
        this.code = res.data[0]
        let num = 60
        this.forgetCodeBtnWord = num + '后重新获取'
        result = setInterval((_) => {
          if (num <= 0) {
            this.forgetCodeBtnWord = '获取验证码'
            this.timer = true;
            clearInterval(result)
          } else {
            num--;
            this.forgetCodeBtnWord = num + 's重新获取'
            this.timer = false
          }
        }, 1000);
      }
    },
    // 密码的隐藏和显示
    showPass(is) {
      // 点击图标是密码隐藏或显示
      if (is == "1") {
        if (this.getPassw == "text") {
          this.getPassw = "password";
          // 睁眼
          this.showGetPassword = true;
        } else {
          this.getPassw = "text";
          // 闭眼
          this.showGetPassword = false;
        }
      } else {
        if (this.passw == "text") {
          this.passw = "password";
          // 睁眼
          this.showPassword = true;
        } else {
          this.passw = "text";
          // 闭眼
          this.showPassword = false;
        }
      }
    },

    // 清空表单
    reset() {
      this.loginForm = {
        username: "", // 账号
        password: "", // 密码
        mobile: "", // 手机号
        rememberMe: false, // 复选框勾选
        rememberPassword: false, // 记住密码
        formCode: "", // 验证码
        password: "", // 设置新密码
        confirm_password: "", // 确认新密码
        provingCode: "" // 身份验证验证码
      };
    },
    async getUserInfo(id) {
      const res = await getInfo({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      })
      if (res.code === 200) {
        this.$store.commit('editUserInfo', res.data);
        this.$emit('finish', id)
        // this.$router.push('/choose')
        // this.$router.push('/home/index')
      }
    },
    // 注册后登录或直接登录
    regisOrLogin() {
      const parmas = {
        mobile: this.loginForm.mobile,
        password: this.$md5(this.loginForm.password)
      }
      login(parmas).then((res) => {
        if (res.code === 200) {
          localStorage.setItem('name', this.loginForm.mobile)
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('secret', res.data.secret)
          if (res.data.hospital[0]) {
            localStorage.setItem('hospital_id', res.data.hospital[0].id)
          } else {
            localStorage.setItem('hospital_id', '')
          }
          if (this.remember) {
            localStorage.setItem('password', this.loginForm.password)
          } else {
            localStorage.removeItem('password')
          }
          if (res.data.hospital.length === 1) {
            this.$message.success(res.message)
            this.getUserInfo(res.data.hospital[0].id);
          } else if (res.data.hospital.length === 0) {
            res.data.phone = this.loginForm.mobile
            this.$store.commit('editUserInfo', res.data);
            this.$emit('finish')
          } else {
            this.$emit('choose', res.data)
          }
        }
      }, (error) => {
      })
    },
    // 登录
    handleLogin(val) {
      this.$refs['loginForm'].validate(async (valid) => {
        if (valid) {
        //   if (!this.isPassing) {
        //     return this.$message.error('请先进行滑块验证')
        //   }
          if (val == 1) {
            this.regisOrLogin()
          } else if(val == 2) {
            codeCheck({
              mobile: this.loginForm.mobile,
              code: this.loginForm.formCode
            }).then(res => {
              if (res.code == 200) {
                const parmas = {
                  mobile: this.loginForm.mobile,
                  password: this.$md5(this.loginForm.password),
                  confirm_password: this.$md5(this.loginForm.confirm_password),
                  formCode: this.loginForm.formCode
                }
                modifyPasswordByMobile(parmas).then(res2 => {
                  if (res2.code === 200) {
                    this.$message.success('修改成功');
                    this.loginStatus = 1
                    this.$refs["loginForm"].resetFields();
                    this.$nextTick(() => {
                      this.$refs["loginForm"].clearValidate();
                    });
                    this.reset();
                  }
                })
              }
            })
          }else if(val === 3){
            this.loading = true
            const data = {
              mobile:this.loginForm.mobile,
              code:this.loginForm.formCode,
              password:this.loginForm.password,
              confirm_password:this.loginForm.confirm_password,
            }
            const res = await registerToYkbApi(data)
            if(res.code === 200){
              this.regisOrLogin()
            }
            this.loading = false
          }
        }
      });
    }
  }

}
</script>
  <style lang="scss">
  :root{
      --scale:1,
  }
  $scale:var(--scale, 1);
  input:-internal-autofill-selected {
      background-color: transparent !important;
  }
  input {
        background-color:transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: calc(#{$scale} * 12px) calc(#{$scale} * 5px) calc(#{$scale} * 12px) calc(#{$scale} * 15px);
        height: calc(#{$scale} * 47px);
        // caret-color: $cursor;
        font-size: calc(#{$scale} * 16px);

        &:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
          -webkit-text-fill-color: #FFFFFF !important;
            -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
          background-color:transparent;
          background-image: none;
          transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
        }
      }

  .loginD{
      position: fixed;
      top:0px;
      left:0px;
      width: calc(#{$scale} * 1920px);
      height: calc(#{$scale} * 1080px);
      background: rgba(0,14,14,0.16);
      backdrop-filter: blur(8px);
      z-index: 999;
      display: flex;
      flex-direction: row;
      justify-content: center;
      .el-input--medium{
        font-size: calc(#{$scale} * 16px);

      }
      .el-form-item__error{
        font-size: calc(#{$scale} * 12px);
        padding-top: calc(#{$scale} * 4px);

      }
      .el-checkbox__input{
        height: calc(#{$scale} * 16px);
        width: calc(#{$scale} * 16px);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: #DD594A;
        border: 1px solid #DD594A !important;
        height: calc(#{$scale} * 16px);
        width: calc(#{$scale} * 16px);
        border-radius:  0;
      }
      .el-checkbox__inner::after{
        height: calc(#{$scale} * 7px);
        width: calc(#{$scale} * 3px);
        left: calc(#{$scale} * 4px);
        top: calc(#{$scale} * 1px);
      }

      .loginDCon{
        margin-top: calc(#{$scale} * 174px);
        width: calc(#{$scale} * 548px);
        height: calc(#{$scale} * 580px);
        background: rgba(0, 24, 28, 0.7);
        border-radius: calc(#{$scale} * 16px);
        backdrop-filter: blur(10px);
        position: relative;
        .operateButton{
          .usernameLoginStyle{
            font-size: calc(#{$scale} * 16px);
            width:calc(#{$scale} * 120px);
            height: calc(#{$scale} * 40px);
            line-height: calc(#{$scale} * 40px);
            cursor: pointer;

          }
        }
        .appQStyle{
          display: flex;
          flex-direction: column;
          align-items: center;
          .appQImg{
            width: calc(#{$scale} * 240px);
            height: calc(#{$scale} * 240px);
            background: #FFFFFF;
            border-radius: calc(#{$scale} * 12px);
            margin-bottom: calc(#{$scale} * 16px);
            overflow: hidden;
            position: relative;
            div{
              position: absolute;
              top:0px;
              left:0px;
              width: calc(#{$scale} * 240px);
              height: calc(#{$scale} * 240px);
              background: rgba(0,0,0,0.6);
              border-radius: calc(#{$scale} * 12px);
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              span:first-child{
                display: inline-block;
                width: calc(#{$scale} * 24px);
                height: calc(#{$scale} * 24px);
                margin-bottom:calc(#{$scale} * 12px);
                background-image: url("~@/assets/img/refreshIcon.png");
                background-repeat: no-repeat;
                background-size: calc(#{$scale} * 24px) calc(#{$scale} * 24px);

              }
              span:last-child{
                display: inline-block;
                height: calc(#{$scale} * 28px);
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: calc(#{$scale} * 14px);
                color: #FFFFFF;
                line-height: calc(#{$scale} * 28px);
                text-align: left;
                font-style: normal;
              }

            }
            img{
              width: calc(#{$scale} * 240px);
              height: calc(#{$scale} * 240px);
            }
          }
          p{
            height: calc(#{$scale} * 28px);
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: calc(#{$scale} * 14px);
            color: #B4E3DE;
            line-height: 28px;
            text-align: left;
            font-style: normal;
          }
        }
        .switchLoginTypeStyle{
          position: absolute;
          top:calc(#{$scale} * 225px);
          right:calc(#{$scale} * 17px);
          height: calc(#{$scale} * 46px);
          display: flex;
          align-items: center;
          span{
            // display: inline-block;
            // width: calc(#{$scale} * 34px);
            // height: calc(#{$scale} * 34px);
            // background-size:calc(#{$scale} * 34px) calc(#{$scale} * 34px) ;
            // background-position: center;
            // border-radius: calc(#{$scale} * 17px);
            // background-color: rgba(13,33,40,0.5);
            // cursor: pointer;
          }
          span:hover{
            // background-color: rgba(0, 174, 159, 1);
            // position: relative;
          }
          span:hover::after{
            // position: absolute;
            // top:calc(#{$scale} * -38px);
            // left:50%;
            // margin-left:calc(#{$scale} * -36px);
            // display: inline-block;
            // width: calc(#{$scale} * 72px);
            // height: calc(#{$scale} * 33px);
            // border-radius: calc(#{$scale} * 17px);;
            // line-height: calc(#{$scale} * 33px);
            // background: rgba(13,33,40,0.5);
            // backdrop-filter: blur( calc(#{$scale} * 4px) );
            // font-weight: 400;
            // font-size: calc(#{$scale} * 12px);
            // color: #B4E3DE;
            // text-align: center;
          }
          span:hover::before{
            // content: "";
            // display: inline-block;
            // position: absolute;
            // top:calc(#{$scale} * -5px);
            // left:50%;
            // margin-left:calc(#{$scale} * -3px);
            // width: 0;
            // height: 0;
            // border-width: 3px;
            // border-style: solid;
            // border-color: rgba(13,33,40,1) transparent transparent transparent;
          }

        //   .usernameLoginStyle{
        //     background-image: url("~@/assets/img/codeLoginIcon.png");
        //   }
        //   .usernameLoginStyle:hover{
        //     background-image: url("~@/assets/img/codeLoginActionIcon.png");
        //   }
          .usernameLoginStyle:hover::after{
            // width: calc(#{$scale} * 82px);
            // margin-left:calc(#{$scale} * -41px);
            // content: "验证码登录";
          }
          .codeLoginStyle{
            background-image: url("~@/assets/img/usernameLoginIcon.png");
          }
          .codeLoginStyle:hover{
            background-image: url("~@/assets/img/usernameLoginActionIcon.png");
          }
          .codeLoginStyle:hover::after{
            content: "密码登录";
          }

        }

        .orgLogo{
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: calc(#{$scale} * 42px);
          margin-bottom: calc(#{$scale} * 38px);
          img{
            height: calc(#{$scale} * 66px);
            width: auto;
          }
        }
        .loginTypeSwitch{
          display: flex;
          flex-direction: row;
          justify-content:center;
          list-style: none;
          margin:0 calc(#{$scale} * 50px) calc(#{$scale} * 45px) calc(#{$scale} * 50px);
          font-weight: 400;
          font-size:calc(#{$scale} * 20px);
          height:calc(#{$scale} * 36px) ;
          li{
            text-align: center;
            width: calc(#{$scale} * 168px);
            cursor: pointer;

          }
          color: #B4E3DE;
          .loginTypeAction{
            font-weight: 600;
            font-size: calc(#{$scale} * 24px);
            color: #FFFFFF;
            position: relative;
          }
          .loginTypeAction::after{
            content: "";
            display: block;
            width: calc(#{$scale} * 28px);
            height: calc(#{$scale} * 4px);
            background: #DD594A;
            border-radius: calc(#{$scale} * 2px);
            position:absolute;
            top:calc(#{$scale} * 40px);
            left:50%;
            margin-left:calc(#{$scale} * -14px)

          }
        }
        .login-form{
          margin:0 calc(#{$scale} * 56px);
          .el-checkbox__inner{
            border-color:#FFFFFF;
            height: calc(#{$scale} * 16px);
            width: calc(#{$scale} * 16px);
            border-radius:  0;
          }
          .is-checked::after{
            background-color: #DD594A;
            border:none;
          }
          .el-form-item{
            line-height: 0px;
            margin-bottom:calc(#{$scale} * 20px);
            .loginInitStyle{
              word-wrap: break-word;
                word-break: break-all;
              margin-top:calc(#{$scale} * 8px);
              color:#ff4949;
              font-size: calc(#{$scale} * 16px);
              line-height: calc(#{$scale} * 16px);
            }
            .el-form-item__content{
              line-height: 0px;
            }

            .loginInput{
              display: flex;
              height: calc(#{$scale} * 48px);
              line-height: calc(#{$scale} * 48px);
              .el-input__inner{
                padding-left: calc(#{$scale} * 30px);
                line-height: calc(#{$scale} * 46px);
              }
              .el-input__prefix{
                left: calc(#{$scale} * 5px);
              }
              input{
                width:  calc(#{$scale} * 436px);
                height: calc(#{$scale} * 46px);
                border-radius: calc(#{$scale} * 8px);
                border: calc(#{$scale} * 1px) solid rgba(138,220,211,0.16);
                background-color: transparent;
                color:#FFFFFF;
                text-indent: calc(#{$scale} * 4px);
                font-size: calc(#{$scale} * 16px);
              }
              input::placeholder{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size:  calc(#{$scale} * 16px);
                color: rgba(180,227,222,0.6);
                text-align: left;
                font-style: normal;
              }
              .el-input__prefix, .el-input__suffix{
                height: calc(#{$scale} * 46px);
                line-height: calc(#{$scale} * 46px);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                .el-input__suffix-inner{
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                }
                img{
                  // margin-top:calc(#{$scale} * 11px);
                  height: calc(#{$scale} * 24px);
                  width:calc(#{$scale} * 24px);
                }
                .passwordIcon{
                  width:calc(#{$scale} * 36px);
                  height: calc(#{$scale} * 36px);
                  margin-left: calc(#{$scale} * -4px);
                }
              }
            }
          }
          .passwordOperation{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            height: calc(#{$scale} * 30px);
            .CheckButton{
              font-weight: 400;
              font-size: calc(#{$scale} * 14px);
              color: #fff;
              height: calc(#{$scale} * 30px);
              display: flex;
              flex-direction: row;
              align-items: center;
              .loginCheckboxText{
                // margin-top:calc(#{$scale} * 4px);
                display: block;
                margin-left:calc(#{$scale} * 10px);
              }
              .loginCheckbox{
                width: calc(#{$scale} * 16px);
                height: calc(#{$scale} * 16px);
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }

            .forgetButton{
              display: block;
              font-weight: 400;
              font-size: calc(#{$scale} * 14px);
              color: #fff;
              text-align: left;
              font-style: normal;
              cursor: pointer;
            }
          }
          .buttonlogin{
            width: calc(#{$scale} * 436px);
            height: calc(#{$scale} * 48px);
            background: #DD594A;
            border-radius: calc(#{$scale} * 8px);
            border:none;
            margin-left:0px;
            margin-top:calc(#{$scale} * 37px);
            color:#FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            padding:0px;
            span{
              font-size: calc(#{$scale} * 18px);
            }
          }
          .button-registered{
            width: calc(#{$scale} * 436px);
            height: calc(#{$scale} * 48px);
            border-radius: calc(#{$scale} * 8px);
            border: solid 1px #DD594A;
            margin-left:0px;
            margin-top:calc(#{$scale} * 37px);
            margin-top:calc(#{$scale} * 37px);
            color:#DD594A;
            display: flex;
            align-items: center;
            justify-content: center;
            padding:0px;
            background: transparent;
            span{
              font-size: calc(#{$scale} * 18px);
            }
          }

        }
        .agreementCheckbox{
          width: calc(#{$scale} * 316px);
          display: flex;
          flex-direction: row;
          align-items: center;
          margin:0 auto;
          margin-top: calc(#{$scale} * 28px);
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: calc(#{$scale} * 14px);
          color: #B4E3DE;
          text-align: left;
          font-style: normal;
          .el-button{
            font-size: calc(#{$scale} * 14px);
          }

        }
        .closeBut{
          position: absolute;
          top:calc(#{$scale} * 9px);
          right: calc(#{$scale} * 9px);
          width: calc(#{$scale} * 32px);
          height: calc(#{$scale} * 32px);
          border-radius: calc(#{$scale} * 16px);
        }
        .serviceStyle{
          position: absolute;
          top:calc(#{$scale} * 9px);
          right: calc(#{$scale} * 56px);
          width: calc(#{$scale} * 32px);
          height: calc(#{$scale} * 32px);
          border-radius: calc(#{$scale} * 16px);
          background-color:rgba(18, 43, 49, 0.5);
          background-image: url("~@/assets/img/serviceIcon.png");
          background-size: calc(#{$scale} * 32px) calc(#{$scale} * 32px);
          background-repeat: no-repeat;
          background-position: center;
          border: 1px solid rgba(138,220,211,0.16);
          .tooltip{
            width: calc(#{$scale} * 72px);
            height: calc(#{$scale} * 30px);
            border-radius: calc(#{$scale} *15px);
            background: rgba(13,33,40,0.5);
            opacity: 0;
            font-weight: 400;
            font-size:  calc(#{$scale} * 12px);
            color: #FFFFFF;
            line-height:  calc(#{$scale} * 30px);
            text-align: center;
            font-style: normal;
            position:absolute;
            top: calc(#{$scale} * -43px);
            right: calc(#{$scale} * -20px);
            transition: all 0.3s ease;
          }
          .tooltip::after{
            position: absolute;
            top:calc(#{$scale} * 30px);
            right: calc(#{$scale} * 32px);
            content: "";
            display: inline-block;
            width: 0;
            height: 0;
            border-width: calc(#{$scale} * 4px);;
            border-style: solid;
            border-color: rgba(13,33,40,0.5) transparent transparent transparent;
          }

        }
        .serviceStyle:hover{
          background-color: rgba(0, 179, 163, 1);
          background-image: url("~@/assets/img/serviceIconAction.png");
          border:none;
          .tooltip{
            opacity: 1;
            visibility: visible;
          }
        }
      }
      .agreementPrivacy{
        margin-top:calc(#{$scale} * 174px);
        background: rgba(0, 24, 28, 0.6);
        border-radius: calc(#{$scale} * 16px);
        backdrop-filter: blur(10px);
        height:calc(#{$scale} * 680px);
        width:calc(#{$scale} * 680px);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding:calc(#{$scale} * 27px) calc(#{$scale} * 40px) calc(#{$scale} * 32px) calc(#{$scale} * 40px);
        position: relative;
        h2{
          height: calc(#{$scale} * 33px);
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: calc(#{$scale} * 24px);
          color: #FFFFFF;
          line-height: calc(#{$scale} * 33px);
          text-align: center;
          font-style: normal;
          margin-bottom:calc(#{$scale} * 12px);
        }
        .agreementPrivacyCantentBodyHTML{
          height:calc(#{$scale} * 576px);
          width:calc(#{$scale} * 600px);
          overflow: scroll;
          color:#FFFFFF;
          .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6{
            line-height: calc(#{$scale} * 24px);
            padding:calc(#{$scale} * 8px) 0;
          }
          span, p, br{
            font-size: calc(#{$scale} * 16px) !important;
          }
        }
        .closeBut{
          position: absolute;
          top:calc(#{$scale} * 32px);
          right: calc(#{$scale} * 29px);
          width: calc(#{$scale} * 32px);
          height: calc(#{$scale} * 32px);
          border-radius: calc(#{$scale} * 16px);
        }

      }
      .UserAgreement{
        margin-top: calc(#{$scale} * 274px);
        background: rgba(0, 24, 28, 0.6);
        border-radius: calc(#{$scale} * 16px);
        backdrop-filter: blur(10px);
        height:calc(#{$scale} * 250px);
        width:calc(#{$scale} * 400px);
        display: flex;
        flex-direction: column;
        align-items: center;
        padding:calc(#{$scale} * 34px) calc(#{$scale} * 60px) calc(#{$scale} * 30px) calc(#{$scale} * 60px);
        .title{
          font-weight: 500;
          font-size: calc(#{$scale} * 20px);
          color: #FFFFFF;
          text-align: center;
          font-style: normal;
          margin-bottom:calc(#{$scale} * 14px);

        }
        .text{
          font-weight: 400;
          font-size: calc(#{$scale} * 16px);
          color: #FFFFFF;
          text-align: center;
          font-style: normal;
          margin:calc(#{$scale} * 7px) 0;
        }
        .agreement{
          color:rgba(0, 174, 159, 1);
          font-size: calc(#{$scale} * 16px);
          span{
            cursor: pointer;
          }
          span:nth-child(2){
            color:#FFFFFF;
            cursor: auto;
          }
        }
        .buttonBox{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          div{
            height: calc(#{$scale} * 48px);
            border-radius: calc(#{$scale} * 24px);
            line-height: calc(#{$scale} * 48px);
            font-size: calc(#{$scale} * 18px);
            font-style: normal;
            text-transform: none;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            margin-top:calc(#{$scale} * 28px);
            cursor: pointer;
          }
          .left{
            width: calc(#{$scale} * 115px);
            border: calc(#{$scale} * 1px) solid #DD594A;
            color: #DD594A;
          }
          .right{
            width: calc(#{$scale} * 120px);
            background: #DD594A;
            color: #FFFFFF;
          }
        }

      }

  }
  </style>
